import { render } from "./HomeIbase.vue?vue&type=template&id=4e9517e2&scoped=true"
import script from "./HomeIbase.vue?vue&type=script&lang=js"
export * from "./HomeIbase.vue?vue&type=script&lang=js"

import "./HomeIbase.vue?vue&type=style&index=0&id=4e9517e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e9517e2"]])

export default __exports__